export default __webpack_public_path__ + "static/media/files.b1bb9417.svg";